<div *ngIf="meeting">
  <button
    class="bg-light border border-neutral-200 rounded p-[11px] mobile:mb-7 tablet:mb-9 hover:bg-neutral-50 active:bg-neutral-200"
    title="Back to dashboard"
    (click)="back()">
    <img src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/icons/arrow_back.svg">
  </button>
  <div class="text-neutral-500 text-2 font-medium uppercase mb-4 leading-13 tracking-[1.04px]">
    {{meeting.status == InterviewStatus.ACCEPTED ? 'Interview details' : 'choose a date and time'}}
  </div>
  <div class="flex justify-between">
    <div class="text-dark text-7 font-medium leading-30">{{dashboardInfo?.jobTitle}}</div>
    <span
      *ngIf="meeting.status == InterviewStatus.ACCEPTED"
      class="hidden tablet:inline-table tablet:items-center px-5 border border-success-300 bg-success-50 rounded-[37px]">
      <span class="text-success-700 text-[13px] leading-[30px]">Interview Confirmed</span>
    </span>
  </div>
  <div class="mt-4">
    <interview-location-widget
      [PhoneCallAltText]="true"
      [meeting]="meeting"
      [dashboardInfo]="dashboardInfo"
    ></interview-location-widget>
  </div>

  <div class="rounded border-1 border-[#EFF0F1] shadow-mdlight bg-light mt-6 mb-6 py-6 px-[6px] tablet:p-[48px]">
    <div id="cronofy-date-time-picker"></div>
  </div>

  <decline-interview-widget
    *ngIf="!meetingInThePast(meeting)"
    [meeting]="meeting"
    (onDeclineInterviewClicked)="declineInterview($event)"
  ></decline-interview-widget>
</div>
